import React, { memo } from 'react';
import MethodBadge from '../ApiDocsViewer/MethodBadge/MethodBadge';
import { FileOutlined, FolderOpenOutlined, FolderOutlined } from '@ant-design/icons';
import { EMOJI_MAP } from 'editor/src/components/EmojiPicker/data';

export const ExplorerIcon = ({ nodeType }) => {
  switch (nodeType) {
    case 'folder':
      return <FolderOutlined />;
    case 'folder-open':
      return <FolderOpenOutlined />;

    case 'file':
      return <FileOutlined />;

    case 'service_releases_folder_id':
      return (
        <svg width={'16'} height={'16'} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none">
          <path
            d="M8 16H56C58.2091 16 60 17.7909 60 20V56C60 58.2091 58.2091 60 56 60H8C5.79086 60 4 58.2091 4 56V20C4 17.7909 5.79086 16 8 16Z"
            fill="#F8B400"
          />
          <path
            d="M8 18C7.44772 18 7 18.4477 7 19V55C7 55.5523 7.44772 56 8 56H56C56.5523 56 57 55.5523 57 55V19C57 18.4477 56.5523 18 56 18H30V12H8Z"
            fill="#FFDA44"
          />
          <path d="M8.5 7H26.5C27.0523 7 27.5 7.44772 27.5 8V19H7.5V19C7.5 18.4477 8.5 16 10 16H8V7Z" fill="#AAB8C2" />
          <path d="M30 12H56V18H30V12Z" fill="#AAB8C2" />
          <path d="M35 12V16H56V12H35Z" fill="#333" />
          <path d="M20 26H44V30H20V26Z" fill="#333" />
          <path d="M20 34H44V38H20V34Z" fill="#333" />
          <path d="M20 42H44V46H20V42Z" fill="#333" />
          <path d="M12 51H52V55H12V51Z" fill="#333" />
        </svg>
      );

    case 'service_releases_page_id':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={'16'}
          height={'16'}
          viewBox="0 0 64 64"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="8" y="4" width="48" height="56" rx="3" ry="3" fill="#f9f9f9" stroke="#e0e0e0" />
          <path d="M8 4 L32 4 L32 12 L8 12 Z" fill="#e0e0e0" />
          <path d="M16 20 L48 20" stroke="#0078d4" />
          <path d="M16 28 L48 28" stroke="#0078d4" />
          <path d="M16 36 L48 36" stroke="#0078d4" />
          <path d="M16 44 L48 44" stroke="#0078d4" />
          <path d="M16 52 L48 52" stroke="#0078d4" />
          <circle cx="54" cy="10" r="4" fill="#0078d4" />
          <path d="M40 10 L20 10" stroke="#FFFFFF" strokeWidth="1.5" />
          <line x1="54" y1="6" x2="54" y2="14" stroke="#FFFFFF" strokeWidth="1.5" />
          <path d="M32 41 L35 37 L39 41" stroke="#0078d4" fill="none" strokeWidth="2" />
          <path d="M32 48 L35 45 L39 48" stroke="#0078d4" fill="none" strokeWidth="2" />
        </svg>
      );

    case 'service_details_page_id':
      return (
        <svg width={'16'} height={'16'} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
          <rect x="2" y="2" width="20" height="20" rx="4" fill="#F5F5F5" stroke="#E0E0E0" stroke-width="2" />
          <path d="M6 8H18M6 12H12M6 16H18" stroke="#3F51B5" stroke-width="1.5" stroke-linecap="round" />
          <circle cx="18" cy="8" r="1.5" fill="#4CAF50" />
          <circle cx="12" cy="12" r="1.5" fill="#FFC107" />
          <circle cx="18" cy="16" r="1.5" fill="#F44336" />
          <path d="M20 4H4V20H20V4Z" stroke="#3F51B5" stroke-width="2" />
        </svg>
      );
    default:
      return nodeType in EMOJI_MAP ? EMOJI_MAP[nodeType] : <MethodBadge method={nodeType} />;
  }
};

export const DropdownIcon = memo(({ node, isOpen, className }) => {
  return (
    <div className={`expand-icon-wrapper ${isOpen ? 'is-open' : ''} ${className}`}>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10.5866 5.99969L7.99997 8.58632L5.41332 5.99969C5.15332 5.73969 4.73332 5.73969 4.47332 5.99969C4.21332 6.25969 4.21332 6.67965 4.47332 6.93965L7.5333 9.99965C7.59497 10.0615 7.66823 10.1105 7.7489 10.144C7.82957 10.1775 7.91603 10.1947 8.0033 10.1947C8.09063 10.1947 8.1771 10.1775 8.25777 10.144C8.33837 10.1105 8.41163 10.0615 8.4733 9.99965L11.5333 6.93965C11.7933 6.67965 11.7933 6.25969 11.5333 5.99969C11.2733 5.74635 10.8466 5.73969 10.5866 5.99969Z"
          fill="inherit"
        />
      </svg>
    </div>
  );
});

export default ExplorerIcon;
